// @Vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';

class InputGrp extends Component {
  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
  };
  
  static defaultProps = {
    className: '',
    id: null,
    onChange: () => {},
  };

  render() {
    const {
      children,
      className,
      id,
      name,
      onChange,
      type,
      ...rest
    } = this.props;

    return (
      <Field
        name={name}
        type='text'
        render={({ input, meta }) => {
          const invalid = meta.touched && meta.error ? true : false;
          return (
            <FormControl>
              <TextField
                className={classNames(className)}
                id={id}
                type={type}
                error={invalid}
                {...rest}
                {...input}
                onChange={e => {
                  input.onChange(e);
                  if(onChange) onChange(e.target.value);
                }}
              >
                {children}
              </TextField>
              {invalid && <FormHelperText error>{meta.error}</FormHelperText>}
            </FormControl>
          )
        }}
      />
    );
  }
}

export default InputGrp;



// WEBPACK FOOTER //
// ./src/components/form/InputGrp.js